import React from "react";
import CallFormWizard from "./callform/components/CallFormWizard";
import Projects from "./projects/components/Projects";
import ProjectCreate from "./projects/components/Create";
import StatsView from "./stats/components/StatsView";
import ProjectConfig from "./projectconfig/components/ProjectConfig";
import AboutUs from "./AboutUs";
import Logout from "./auth/components/Logout";
import Users from "./users/components/Users";
import ViewUser from "./users/components/View";
import UpdateUser from "./users/components/Update";
import ViewProject from "./projects/components/ViewProject";
import Groups from "./projects/components/Groups.jsx";
import PinGeneration from "./projects/components/PinGeneration";
import ViewPins from "./projects/components/ViewPins";
import CallLog from "./pin/components/CallLog";
import PinLog from "./pin/components/PinLog";
import CallReportsView from "./reports/components/CallReportsView";
import Admin from "./admin/components/Admin";
import NotFound from "./etc/NotFound";
import { Switch, Route } from 'react-router-dom';
import { withApollo } from "react-apollo";
import ManagerRoute from './etc/ManagerRoute';
import { withRouter } from "react-router";

class Content extends React.Component {
    constructor(props){
        super(props)
    }
    render(){
        var that = this;
        let initialPage = CallFormWizard;
        let isAdmin = false;

        let userType = localStorage.getItem("APN_USERTYPE");
        if (userType == process.env.REACT_APP_ADMIN_ROLE || 
                userType == process.env.REACT_APP_PM_ROLE) 
            isAdmin = true;

        if (isAdmin) {
            initialPage = Projects;
        }
        
        var head = '';
        var path = this.props.location.pathname;

        if (path == '/'){
            head = (isAdmin) ? 'Projects' : 'Call'
        }
        else{
            head = path.split('/')[1];
            head = head[0].toUpperCase() + head.slice(1,head.length);
        }


        
        return(
            <main>
                <Switch>
                    <Route exact path="/" component={initialPage} />
                    <Route exact path="/admin" component={Admin} />
                    <Route exact path="/callform" component={CallFormWizard} />
                    <ManagerRoute exact path="/projects/callform/:id" component={CallFormWizard} />
                    <ManagerRoute exact path="/projects" component={Projects} />
                    <ManagerRoute exact path="/projects/:id" component={ViewProject} />
                    <ManagerRoute exact path="/projects/:projid/groups" component={Groups} />
                    <ManagerRoute exact path="/projects/:id/pins" component={ViewPins} />
                    <ManagerRoute exact path="/projects/pin/:id" component={CallLog} />
                    <ManagerRoute exact path="/projects/:id/webInterface" component={ProjectConfig} />
                    <ManagerRoute exact path="/projects/generate_pins/:id" component={PinGeneration} contentstate={that.state} />
                    <ManagerRoute exact path="/projects/create" component={ProjectCreate} />
                    <ManagerRoute exact path="/users" component={Users} />
                    <ManagerRoute exact path="/users/project/:pid" component={Users} />
                    <ManagerRoute exact path="/users/:uid" component={ViewUser} />
                    <ManagerRoute exact path="/users/:uid/update" component={UpdateUser} />
                    <ManagerRoute exact path="/stats" component={StatsView} />
                    <ManagerRoute exact path="/aboutus" component={AboutUs} />
                    <ManagerRoute exact path="/callreports" component={CallReportsView} />
                    <ManagerRoute exact path="/projects/:id/logs" component={PinLog} />
                    <Route exact path="/logs" component={PinLog} />
                    <Route exact path="/notfound" component={NotFound} />
                    <Route exact path="/logout" component={Logout} />
                    <Route exact path="/*" component={NotFound} />
                </Switch>
            </main>
           )
    }
}

export default withRouter(Content)


// WEBPACK FOOTER //
// ./src/views/Content.js